<template>
  <div v-cloak v-if="template" class="item-common pt-10 pb-15 px-7">
    <div class="header">
      <h1 class="title">포트폴리오</h1>
      <v-divider></v-divider>
      <p class="desc" v-html="template.guideResumeUpload"></p>
    </div>
    <div class="body">
      <v-form ref="form">
        <template v-for="(item, i) in items">
          <v-row class="mt-8" :key="'file' + i">
            <v-col cols="12" style="font-weight: bold;" class="my-4">
              {{ item.value }}</v-col
            >
            <v-col cols="12">
              <div
                v-if="item.loading"
                class="file-upload-wrap"
                style="border-style:solid;background:#eceff1;"
              >
                <v-progress-circular
                  indeterminate
                  size="40"
                  color="#90a4ae"
                ></v-progress-circular>
              </div>
              <div
                v-else-if="item.fileId"
                class="file-upload-wrap"
                style="border-style:solid;background:#eceff1; position:relative"
              >
                <v-icon
                  class="my-1"
                  x-large
                  :color="item.fileIcon.color || '#90A4AE'"
                >
                  {{ item.fileIcon.icon || 'mdi-file-outline' }}
                </v-icon>
                <span class="mb-3" style="font-size:0.8rem">{{
                  item.fileName
                }}</span>

                <div>
                  <span
                    class="btn px-2 py-1 mr-2"
                    @click="downLoad(item.fileId, i)"
                    >다운로드</span
                  >
                  <span class="btn px-2 py-1" @click="onClick(i)"
                    >파일 변경</span
                  >
                </div>

                <v-tooltip bottom>
                  <template v-slot:activator="{ on, attrs }">
                    <v-btn
                      style="position:absolute;top:0;right:0"
                      v-on="on"
                      v-bind="attrs"
                      @click="deleteFile(item.id, i)"
                      icon
                      fab
                      dark
                      small
                      color="#78909c"
                    >
                      <v-icon>mdi-close</v-icon>
                    </v-btn>
                  </template>
                  <span>파일 삭제</span>
                </v-tooltip>
              </div>

              <div
                v-else
                @dragover.prevent="isActiveDropZone = true"
                @dragleave="isActiveDropZone = false"
                @drop="e => opDrop(e, i)"
                @click="onClick(i)"
                class="file-upload-wrap cursor empty"
                :style="{ background: isActiveDropZone ? '#eceff1' : '' }"
              >
                <v-icon class="my-1" x-large color="#90A4AE"
                  >mdi-file-hidden</v-icon
                >

                <span class="my-2"
                  >PDF 파일을 <strong>업로드</strong> 해주세요.
                </span>
                <span style="font-size:0.7rem"
                  >최대크기 {{ item.limit }} MB</span
                >
              </div>

              <input
                type="file"
                hidden
                ref="fileInput"
                @change="e => onChange(e, i)"
              />
            </v-col>
          </v-row>
        </template>
      </v-form>
    </div>
  </div>
</template>

<script>
import { API, downloadResposne } from '@/api/network';
import { snack } from '@/plugins/dialog/api';
import { getFileIcon, getFileType } from '@/utils/util';
const prefix = number => `resumeUpload${number}`;
export default {
  props: {
    template: { type: Object },
    info: { type: Object },
    opts: { type: Object },
    rules: { type: Object },
    applNo: { Type: String },
    isReadonly: {
      type: Boolean,
      default: function() {
        return true;
      },
    },
  },

  mounted() {
    this.init();
  },
  data: () => ({
    items: [],
    alert: false,
    isActiveDropZone: false,
  }),
  methods: {
    onChange(e, i) {
      const file = e.target.files?.[0];
      this.upload(file, i);
      e.target.value = '';
    },
    onClick(i) {
      this.$refs.fileInput[i].click();
    },
    opDrop(e, i) {
      e.preventDefault();
      this.isActiveDropZone = false;
      const file = e.dataTransfer.files?.[0];
      this.upload(file, i);
    },

    async upload(file, i) {
      if (!file || i == null) return;

      const formData = new FormData();

      const item = this.items[i];
      if (getFileType(file.type) != 'pdf')
        return this.$showAlert('pdf 형식만 업로드 가능합니다.');
      if (item.limit * 1024 * 1024 < file.size)
        return this.$showAlert('최대 용량을 확인해 주세요.');
      try {
        item.loading = true;
        const fileName = file.name;
        const fileType = file.type;
        formData.append('file', file, file.name);
        formData.append(
          'id',
          JSON.stringify(
            item.id || {
              annoId: this.$route.params.annoId,
              applNo: this.applNo,
              cvColumn: this.opts?.[prefix(i + 1)]?.id?.cvColumn,
              seq: 1,
            },
          ),
        );
        item.fileId && formData.append('existingFileId', item.fileId);

        const {
          data: { fileId, id },
        } = await API.postMultipart('/cv/resumeupload', formData);
        Object.assign(this.items[i], {
          fileId,
          id,
          fileName,
          fileIcon: getFileIcon(getFileType(fileType)) || {},
        });
        snack.info('업로드 되었습니다.');
      } catch (error) {
        this.$showAlert(`잘못된 요청입니다.`);
        console.error(error);
      } finally {
        item.loading = false;
      }
    },
    init() {
      if (!this.template) return;
      this.items = Array.from({ length: 10 }, (_, index) => {
        const number = index + 1;

        const item =
          this.info?.resumeUploads?.find(
            item =>
              item.id?.cvColumn == this.opts?.[prefix(number)]?.id?.cvColumn,
          ) ?? {};
        return {
          limit: this.template[`${prefix(number)}Length`] ?? 2,
          value: this.template[`${prefix(number)}`] ?? '',
          yn: this.template[`${prefix(number)}Yn`] || 'N',
          fileName: this.info?.fileMap?.[item.fileId]?.fileName,
          fileId: item.fileId,
          fileIcon:
            getFileIcon(
              getFileType(this.info?.fileMap?.[item.fileId]?.fileType),
            ) || {},
          id: item.id,
          loading: false,
        };
      }).filter(v => v.yn == 'Y');
    },
    valid: function() {
      return this.$refs.form.validate();
    },

    downLoad(fileId, i) {
      this.items[i].loading = true;
      API.getMultipart(`/cv/file/${fileId}`, {
        annoId: this.$route.params.annoId,
      })
        .then(downloadResposne)
        .finally(() => {
          this.items[i].loading = false;
        });
    },

    async deleteFile(id, i) {
      const answer = await this.$confirm('파일을 삭제하시겠습니까?');
      if (!answer) return;
      this.items[i].loading = true;
      try {
        await API.postAuthJson('/cv/resumeupload/delete', id);
        snack.info('삭제 되었습니다.');
        Object.assign(this.items[i], {
          id: null,
          fileId: null,
          fileName: null,
        });
      } catch (error) {
        console.error(error);
      } finally {
        this.items[i].loading = false;
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.cursor {
  cursor: pointer;
}
.v-parallax {
  height: 100% !important;
}
.guide-common {
  min-height: calc(100vh - 64px - 122px);
}

.item-common .header .title {
  font-size: 18px;
  font-weight: bold;
  line-height: 2.67;
  letter-spacing: -0.36px;
  color: #292929;
}
.item-common .header .desc {
  margin-top: 10px;
  font-size: 14px;
  line-height: 1.43;
  letter-spacing: -0.28px;
  color: #555555;
}
.item-common .body {
  margin-top: 22px;
}
.item-common .body .v-divider {
  margin-top: 20px;
  margin-bottom: 20px;
}

.item-common .row {
  margin: 0px;
}
.item-common .col {
  padding: 0px;
}
.item-common .v-text-field {
  min-height: 36px;
}
.btn-post-wrap {
  position: relative;
}
.file-upload-wrap {
  width: 100%;
  height: 180px;
  border: 2px dashed #b0bec5;
  border-radius: 4px;
  padding: 1rem;
  color: #78909c;
  transition: background-color 0.3s, color 0.3s;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  &.empty:hover {
    // &:hover {
    background: #eceff1;
    // }
  }
  .btn {
    font-size: 0.7rem;
    border: 1px solid #90a4ae;
    border-radius: 4px;
    cursor: pointer;
    transition: background-color 0.3s, color 0.3s;
    &:hover {
      background: #90a4ae;
      color: #fefefe;
    }
  }
}
</style>
